import { handleActions } from 'redux-actions';
import { waitMusicActions } from '../actions/waitMusicActions';
function emptyAudio() {
    return {
        chunk_duration_in_secs: 0,
        chunk_urls: [],
        id: '',
        master_file_path: null,
        name: undefined,
    };
}
const initialState = {
    allAudios: [],
    jobIds: [],
    meta: {
        getAsyncStatus: 'succeeded',
        uploadAsyncStatus: 'succeeded',
    },
    selectedAudio: emptyAudio(),
    ui: {
        isNewAudioOpen: false,
        isWaitingOpen: false,
    },
};
export const { waitMusicGetAll, waitMusicGetAllSucceeded, waitMusicGetAllFailed, waitMusicUpload, waitMusicUploadSucceeded, waitMusicUploadFailed, waitMusicSplit, waitMusicSplitSucceeded, waitMusicSplitFailed, waitMusicSelect, waitMusicReset, waitMusicShowModal, waitMusicHideModal, waitMusicWsUploadStatus, waitMusicWaitingForSplitingOpen, waitMusicWaitingForSplitingClose, } = waitMusicActions;
const waitMusic = handleActions({
    [waitMusicGetAll.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getAsyncStatus: 'loading' }) });
    },
    [waitMusicGetAllSucceeded.toString()]: (state, action) => {
        const allAudios = [];
        for (const waitMusic of action.payload.data.wait_music) {
            allAudios.push(Object.assign(Object.assign({}, waitMusic), { id: waitMusic.uuid }));
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getAsyncStatus: 'succeeded' }), allAudios });
    },
    [waitMusicGetAllFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getAsyncStatus: 'failed' }) });
    },
    [waitMusicUpload.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'loading' }) });
    },
    [waitMusicUploadSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isNewAudioOpen: true }) });
    },
    [waitMusicUploadFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'failed' }) });
    },
    [waitMusicSplit.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'loading' }) });
    },
    [waitMusicSplitSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isNewAudioOpen: true }), jobIds: [action.payload.data.job_id, ...state.jobIds] });
    },
    [waitMusicSplitFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'failed' }) });
    },
    [waitMusicWsUploadStatus.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isWaitingOpen: false, isNewAudioOpen: false }), jobIds: state.jobIds.filter((jobID) => jobID !== action.payload.job_id) });
    },
    [waitMusicSelect.toString()]: (state, action) => {
        const selectedAudio = Object.assign({}, action.payload.selectedAudio);
        return Object.assign(Object.assign({}, state), { selectedAudio });
    },
    [waitMusicReset.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { selectedAudio: emptyAudio() });
    },
    [waitMusicShowModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isNewAudioOpen: true }) });
    },
    [waitMusicHideModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isNewAudioOpen: false }) });
    },
    [waitMusicWaitingForSplitingOpen.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isWaitingOpen: true }) });
    },
    [waitMusicWaitingForSplitingClose.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isWaitingOpen: false }) });
    },
}, initialState);
export default waitMusic;
